// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__gO_Zd","topBottomGutter":"Layout_topBottomGutter__3kXVx"};